import Table from '@/common/Table';
import { TableRowProps } from '@/common/Table/TableRow';
import { useTimeIntervalStatsTable } from '@/features/DriveTimeTool/components/TimeIntervalStats/TimeIntervalStatsTable';

export type TimeIntervalHeaderProps = {
  onSort?: (column: string) => void;
  sorting?: { column: string; direction: 'asc' | 'desc' | undefined };
} & TableRowProps;

const TimeIntervalHeader = ({ onSort, ...props }: TimeIntervalHeaderProps): JSX.Element => {
  const [{ sortBy, sortDirection }, setState] = useTimeIntervalStatsTable(({ state, setState }) => [
    {
      sortBy: state.sorting.column,
      sortDirection: state.sorting.direction,
    },
    setState,
  ]);
  const handleSort = (column: string) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    const isSameColumn = sortBy === column;
    let newDirection: 'asc' | 'desc' | undefined;
    if (!isSameColumn) {
      newDirection = 'asc';
    } else if (sortDirection === 'asc') {
      newDirection = 'desc';
    } else if (sortDirection === 'desc') {
      newDirection = undefined;
    } else {
      newDirection = 'asc';
    }
    setState((current) => ({
      ...current,
      sorting: {
        column,
        direction: newDirection,
      },
    }));
  };
  const sorting = (key: string) => ({ direction: sortBy === key ? sortDirection : undefined, onSort: handleSort(key) });

  return (
    <Table.Row {...props} className="TimeIntervalRow" header>
      <Table.Cell className="PeriodCell" sorting={sorting('period')}>
        Period
      </Table.Cell>
      <Table.Cell className="TimeFrameCell" sorting={sorting('timeFrame')}>
        Time Frame
      </Table.Cell>
      <Table.Cell className="WeekdayAvgCell" sorting={sorting('weekdayAvg')}>
        Weekday AVG
      </Table.Cell>
      <Table.Cell className="WeekendAvgCell" sorting={sorting('weekendAvg')}>
        Weekend AVG
      </Table.Cell>
      <Table.Cell className="MinutesCell" sorting={sorting('p60')}>
        60%
      </Table.Cell>
      <Table.Cell className="MinutesCell" sorting={sorting('p80')}>
        80%
      </Table.Cell>
      <Table.Cell className="MinutesCell" sorting={sorting('p90')}>
        90%
      </Table.Cell>
      <Table.Cell className="MinutesCell" sorting={sorting('p95')}>
        95%
      </Table.Cell>
      <Table.Cell className="MinutesCell" sorting={sorting('p99')}>
        99%
      </Table.Cell>
    </Table.Row>
  );
};

export default TimeIntervalHeader;
